<script setup>
const emit = defineEmits(['select'])
defineProps({
    active: Boolean,
    icon: String,
    title: String,
    description: String,
    wide: Boolean,
    info: String
})
</script>

<template>
    <div
        class="flex gap-4 select-none bg-white dark:bg-black dark:border-neutral-700 p-4 rounded-lg max-md:!w-4/5 shadow-sm border items-center max-md:min-w-[220px] cursor-pointer hover:bg-neutral-100 hover:dark:bg-gray-900 transition-all"
        :class="{ 'ring-blue-400 dark:ring-blue-800 ring-2 ring-offset-2 dark:ring-offset-0 ': active, 'w-1/3': wide, 'w-1/4': !wide }"
        @click="emit('select')"
    >
        <slot name="icon">
            <div v-if="icon" class="p-2 bg-gray-200 dark:bg-gray-800 rounded">
                <i :class="icon"></i>
            </div>
        </slot>
        <div class="flex flex-col gap-0 grow">
            <p class="font-bold text-sm">{{ title }}</p>
            <p v-if="description" class="text-sm opacity-70">{{ description }}</p>
        </div>

        <i v-if="info" class="pi pi-info-circle mb-5 opacity-50" v-tooltip="info"></i>
    </div>
</template>

<style scoped lang="scss">

</style>
